import { render, staticRenderFns } from "./Perfume.vue?vue&type=template&id=3adf7dda&scoped=true&"
import script from "./Perfume.vue?vue&type=script&lang=js&"
export * from "./Perfume.vue?vue&type=script&lang=js&"
import style0 from "./Perfume.vue?vue&type=style&index=0&id=3adf7dda&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf7dda",
  null
  
)

export default component.exports